import styled from 'styled-components';
import { colors, spacing, typography } from '../../../styles/theme';

interface Props {
  readonly marginTop?: number;
}

export default styled.h3<Props>`
  font-size: ${typography('fontSize')};
  font-weight: ${typography('weights.bold')};
  padding: ${spacing('1')} 0;
  border-bottom: 2px solid ${colors('black.base')};
  margin-top: ${({ marginTop }: Props) => (marginTop ? `${marginTop}px` : 0)};
`;
